import React from "react";

const SingleChoiceCapture = ({ question, selected, onChange }) => {
  const handleChange = (option) => {
    if (onChange) {
      onChange(option); // Pass the entire option object to parent
    }
  };

  return (
    <div className="flex flex-col w-full">
      {/* Answer Section */}
      <div className="answer-wrapper">
        <h4 className="text-sm uppercase text-indigo-600 mb-4">
          Select Answer
        </h4>
        <div className="space-y-3">
          {question?.options?.map((option) => (
            <label
              key={option._id}
              className="flex items-center space-x-3 cursor-pointer p-3 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <input
                type="radio"
                name={`single-choice-${question._id}`}
                checked={selected?._id === option._id}
                onChange={() => handleChange(option)}
                className="h-5 w-5 text-indigo-600 border-gray-300 focus:ring-indigo-500"
              />
              <span className="text-gray-800">{option.title}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SingleChoiceCapture;
